import actions from './actions'
import mutations from './mutations'

export default {
    namespaced: true,
    actions,
    mutations,
    state: {
        authenticated: false,
        kasConfigurationSettings: {},
        loginContext: 'integrated', // autonomous|integrated (for a VueJs project like StoreWeb)|partial (for an IS project that does not use VueJS like frontofficesymfony)
        loginFormUrl: '',
        logoutSyncUrl: '',
        rawUserInfos: {},
        refreshSyncUrl: '',
        showUserInfos: false,
        unregisterSyncUrl: '',
        userStatusSyncUrl: '',
        userInfos: {},
        userToken: {}
    }
}
